import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
  FormControl,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DebouncedTextField from "common/components/DebouncedTextField";
import Panel from "common/components/Panel";
import Pagination from "common/components/Pagination";
import moment from "moment";
import Resource from "common/components/Resource";
import client from "common/admin/client";
import Snackbar from "@mui/material/Snackbar";

class ListCommunities extends React.Component {
  state = {
    search: "",
    snackbar: "",
    cities: [],
  };

  handleSearchChange = (value) => this.setState({ search: value });

  async componentDidMount() {
    try {
      const cities = await client.get("cities", {
        query: { pagination: false },
      });
      this.setState({ cities });
    } catch (e) {
      this.setState({
        snackbar: "Something went wrong, please try reloading.",
      });
    }
  }

  getCity = (id) => {
    const city = this.state.cities.find((city) => city.id === id);
    return city ? `${city.name}, ${city.region}` : id;
  };

  render() {
    const { classes, history, match } = this.props;
    const { search } = this.state;
    const queryParams = {};
    if (search) {
      queryParams.name_like = search;
    }

    return (
      <Panel title="Neighborhoods">
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={!!this.state.snackbar}
          autoHideDuration={4000}
          onClose={this.handleSnackbarClose}
          message={<span>{this.state.snackbar}</span>}
        />
        <Grid container direction="column" spacing={2}>
          <Grid size={{ xs: 4 }}>
            <FormControl className={classes.search}>
              <DebouncedTextField
                id="search"
                label="Search by name"
                onChange={this.handleSearchChange}
                delay={500}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Resource
          name="communities"
          queryParams={queryParams}
          render={(communities, { removeOne, nextPage, prevPage, page }) => (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>Last Updated</TableCell>
                  <TableCell>Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {communities.length ? (
                  communities.map((community) => (
                    <TableRow hover key={community.id}>
                      <TableCell>{community.id}</TableCell>
                      <TableCell
                        className={classes.clickable}
                        onClick={() =>
                          history.push(`${match.url}/${community.id}`)
                        }
                      >
                        {community.name}
                      </TableCell>
                      <TableCell>{this.getCity(community.city_id)}</TableCell>
                      <TableCell>
                        {moment(community.updated_at).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell>
                        <IconButton>
                          <DeleteIcon onClick={() => removeOne(community.id)} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>No additional data found.</TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={6} className={classes.pagination}>
                    <Pagination
                      page={page}
                      nextPage={nextPage}
                      prevPage={prevPage}
                      items={communities}
                    />
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          )}
        />
      </Panel>
    );
  }
}

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
  pagination: {
    textAlign: "right",
  },
  table: {
    minWidth: 700,
  },
  search: {
    paddingTop: theme.spacing(1),
  },
});

ListCommunities.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListCommunities);
